import axiosInstance from './axiosInstance';
import authSessionIdentity from '@/data/auth/authSessionIdentity';

const getCurrentUserId = () =>
  axiosInstance.get('/users/me').then((response) => {
    const userId = response.data.user_id;
    authSessionIdentity.setUserId(userId);
    return userId;
  });

/**
 * Authenticated user identity transport operations.
 */
export default {
  /**
   * Gets the stable backend user id used to namespace local storage.
   *
   * @returns {Promise<string>} Authenticated user id.
   */
  getCurrentUserId,

  /**
   * Reads the user id already established by an authenticated session.
   *
   * This deliberately performs no HTTP request so local-first consumers can
   * select their database while the network is unavailable.
   *
   * @returns {string|null} Stored user id, if the session has been bootstrapped.
   */
  getStoredUserId: () => authSessionIdentity.getStoredUserId(),

  /**
   * Ensures a restored authenticated session has a locally persisted user id.
   *
   * Existing sessions are bootstrapped once through the remote identity
   * endpoint; subsequent consumers use the stored value without a request.
   *
   * @returns {Promise<string>} Persisted or newly resolved user id.
   */
  ensureStoredUserId: () => {
    const storedUserId = authSessionIdentity.getStoredUserId();
    return storedUserId ? Promise.resolve(storedUserId) : getCurrentUserId();
  }
};
